import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PencilOutlineIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <path d="M2.49927 11.5V14h2.5l7.37333-7.37333-2.5-2.5L2.49927 11.5Zm1.94666 1.1667H3.8326v-.6134l6.04-6.03997.6133.61334-6.03997 6.04003Zm9.85997-8.91337-1.56-1.56C12.6126 2.06 12.4459 2 12.2726 2s-.34.06667-.4667.19333l-1.22 1.22 2.5 2.5 1.22-1.22c.26-.26.26-.68 0-.94Z" />
  </Icon>
);
export default memo(PencilOutlineIcon);
